<template>
  <div class="request">
    <div class="requestData">
      <div class="licenseBlock">
        <h2>MOTORCORTEX Trial License</h2>
        <p>
          Here you can request a trial license for the MOTORCORTEX
          applications. The trial license is valid for 14 days. To
          request the license please fill in this form. In the form
          specify the list of the IP addresses and the domains where
          the application is intended to run.
        </p>
        <h3>Request the license</h3>
        <form>
          <div class="row">
            <div class="column1">
              <label for="cnname">Project name: </label>
            </div>
            <div class="column2">
              <input type="text" id="cnname" name="cnname" class="input" v-model="payload.commonName"
                     :placeholder="placeholder.commonName" :disabled="generating"/>
            </div>
          </div>
          <div class="row">
            <div class="column1">
              <label for="ouname">Organizational Unit: </label>
            </div>
            <div class="column2">
              <input type="text" id="ouname" name="ouname" class="input" v-model="payload.organizationalUnitName"
                     :placeholder="placeholder.organizationalUnitName" :disabled="generating"/>
            </div>
          </div>
          <div class="row">
            <div class="column1">
              <label for="oname">Organization: </label>
            </div>
            <div class="column2">
              <input type="text" id="oname" name="oname" class="input" v-model="payload.organizationName"
                     :placeholder="placeholder.organizationName" :disabled="generating"/>
            </div>
          </div>
          <div class="row">
            <div class="column1">
              <label for="cname">Country: </label>
            </div>
            <div class="column2">
              <input type="text" id="cname" name="cname" class="input" v-model="payload.countryName"
                     :placeholder="placeholder.countryName" :disabled="generating"/>
            </div>
          </div>
          <div class="row">
            <div class="column1">
              <label for="lname">Locality: </label>
            </div>
            <div class="column2">
              <input type="text" id="lname" name="lname" class="input" v-model="payload.localityName"
                     :placeholder="placeholder.localityName" :disabled="generating"/>
            </div>
          </div>
          <div class="row">
            <div class="column1">
              <label for="stname">State or Province: </label>
            </div>
            <div class="column2">
              <input type="text" id="stname" name="stname" class="input" v-model="payload.stateOrProvinceName"
                     :placeholder="placeholder.stateOrProvinceName" :disabled="generating"/>
            </div>
          </div>
          <div class="row">
            <div class="column1">
              <label for="dname">Domains: </label>
            </div>
            <div class="column2">
              <textarea id="dname" name="dname" class="input" v-model="payload.dnsString" rows="3"
                        :placeholder="placeholder.dnsString" :disabled="generating"/>
            </div>
          </div>
          <div class="row">
            <div class="column1">
              <label for="ipname">IPs: </label>
            </div>
            <div class="column2">
              <textarea id="ipname" name="ipname" class="input" v-model="payload.ipString" rows="3"
                        :placeholder="placeholder.ipString" :disabled="generating"/>
            </div>
          </div>
          <div class="row buttonRow">
            <div class="resultColumn">
              <div v-if="generating === false && typeof result !== 'undefined' && error === false"
                   class="resultBlock successBlock">
                <v-icon class="resultIcon" name="check-circle"/>
                <span>{{ result }}</span>
              </div>
              <div v-if="generating === false && typeof result !== 'undefined' && error === true"
                   class="resultBlock errorBlock">
                <v-icon class="resultIcon" name="bug"/>
                <span>{{ result }}</span>
              </div>
              <div v-if="generating === true" class="resultBlock">
                <v-icon class="resultIcon" name="circle-notch" spin/>
                <span>Generating...</span>
              </div>
            </div>
            <div class="buttonColumn">
              <input type="button" id="exampleButton" value="Example" style="margin-right: 8px;" @click="example"/>
              <input type="button" id="generateButton" value="Send" @click="generate" :disabled="generating"
                     style="cursor: pointer;"/>
            </div>
          </div>
        </form>
      </div>
      <div style="margin-bottom: 100px;">
        <h2>Encryption Certificate</h2>
        <p>
          MOTORCORTEX applications are using Transport Layer Security (TLS)
          for end-to-end encryption of the communication channel between the
          server application and its clients. To be able to connect to your
          MOTORCORTEX application you need to use a special certificate signed
          by VECTIONEER.
        </p>
        <p>Download <a :href="publicUri">MOTORCORTEX Encryption Certificate</a>.</p>
        <h3>Install the certificate</h3>
        <p>
          Below you can find an example of how to install the certificate
          in the Chrome browser to enable secured and trusted connection
          to the MOTORCORTEX applications.
        </p>
        <p>
          Open "Settings" menu of the Chrome browser. You can find it
          the top left corner of the window. In the "Settings" menu find
          "Manage certificates" section and select "Authorities" tab.
        </p>
        <img class="image" src="@/assets/chrome_manage_cert.png"/>
        <p>
          Click "Import" button and find the encryption certificate in the "Download"
          folder. Select the option "Trust this certificate for identifying websites".
        </p>
        <img class="image" src="@/assets/chrome_add_cert.png"/>
        <p>
          Verify that the certificate is installed as it is shown on the picture below.
        </p>
        <img class="image" src="@/assets/chrome_imported_cert.png"/>
        <h3>Test connection</h3>
        <p>
          Check if the encryption certificate is installed in the browser correctly.
        </p>
        <div class="row buttonRow">
          <div class="resultColumn">
            <div v-if="testing === false && typeof testResult !== 'undefined' && testError === false"
                 class="resultBlock successBlock">
              <v-icon class="resultIcon" name="check-circle"/>
              <span>{{ testResult }}</span>
            </div>
            <div v-if="testing === false && typeof testResult !== 'undefined' && testError === true"
                 class="resultBlock errorBlock">
              <v-icon class="resultIcon" name="bug"/>
              <span>{{ testResult }}</span>
            </div>
            <div v-if="testing === true" class="resultBlock">
              <v-icon class="resultIcon" name="circle-notch" spin/>
              <span>Testing...</span>
            </div>
          </div>
          <div class="buttonColumn">
            <input type="button" id="testButton" value="Test" @click="test" style="cursor: pointer;"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {createPKCS10, PUBLIC_URI, TEST_URI} from '../js/pki/pkiHelper';

    // download data as file
    let download = function (fileName, fileData) {
        // console.log(fileData)
        const pkcs12AsBlob = new Blob([fileData], {type: 'application/x-pem-file'});
        const downloadLink = document.createElement("a");
        downloadLink.download = `${fileName.trim().toLowerCase()}.pem`
        // noinspection InnerHTMLJS
        downloadLink.innerHTML = "Download File";

        let destroyClickedElement = function (event) {
            document.body.removeChild(event.target);
        }

        downloadLink.href = window.URL.createObjectURL(pkcs12AsBlob);
        downloadLink.onclick = destroyClickedElement;
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);

        downloadLink.click();
    }

    export default {
        name: 'HelloWorld',
        data: function () {
            return {
                payload: {},
                placeholder: {
                    commonName: 'ProjectName',
                    organizationalUnitName: 'Development',
                    organizationName: 'Vectioneer',
                    countryName: 'NL',
                    localityName: 'Karveelweg 19B, 6222 NJ Maastricht',
                    stateOrProvinceName: 'Limburg',
                    dnsString: 'localhost, motorcortex, control.vectioneer.com',
                    ipString: '127.0.0.1, 192.168.2.100'
                },
                generating: false,
                error: false,
                result: undefined,
                testing: false,
                testError: '',
                testResult: undefined,
                publicUri: PUBLIC_URI
            }
        },
        mounted() {
            this.clear()
        },
        methods: {
            example() {
                this.payload = JSON.parse(JSON.stringify(this.placeholder))
            },
            clear() {
                this.result = undefined
                this.payload = {
                    commonName: '',
                    organizationalUnitName: '',
                    organizationName: '',
                    countryName: '',
                    localityName: '',
                    stateOrProvinceName: '',
                    dnsString: 'localhost, motorcortex, control.vectioneer.com',
                    ipString: '127.0.0.1, 192.168.2.100'
                }
            },
            test() {
                this.testResult = undefined
                this.testError = false
                this.testing = true

                fetch(TEST_URI, {method: 'GET'})
                    .then(() => {
                        this.testResult = 'Test completed successfully!'
                    })
                    .catch((error) => {
                        this.testResult = 'Test failed!'
                        this.testError = true
                        console.error(error)
                    })
                    .finally(() => {
                        this.testing = false
                    });
            },
            generate() {
                this.error = true

                let check = Object.values(this.payload).every(property => property !== null && property !== '');

                if (check === false) {
                    this.result = 'Please, fill in all the fields!'
                    return
                }

                this.result = undefined
                this.error = false
                this.generating = true
                createPKCS10(this.payload)
                    .then(result => {
                        download(this.payload.commonName, result)
                        this.result = 'Successfully issued, keep it in a secret place!'
                    })
                    .catch((error) => {
                        console.log(error);
                        this.result = `${error}`
                        this.error = true
                    })
                    .finally(() => {
                        this.generating = false
                    });
            }
        }
    }
</script>

<style scoped>
  h4 {
    margin: 20px 0 10px;
  }

  .request {
    text-align: left;
    font-family: monospace;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .requestData {
    min-width: 64ch;
    max-width: 40%;
    display: flex;
    flex-direction: column;
  }

  .licenseBlock {
    border-bottom: 1px solid black;
    padding-bottom: 20px;
  }

  .resultBlock {
    display: flex;
    align-items: center;
  }

  .successBlock {
    color: forestgreen;
  }

  .errorBlock {
    color: orangered;
  }

  .resultIcon {
    margin-right: 5px;
  }

  p {
    text-align: justify;
  }

  .row {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
  }

  .buttonRow {
    align-items: center;
    margin-top: 25px;
    width: 100%;
  }

  .resultColumn {
    flex-grow: 1;
  }

  .buttonColumn {
    display: flex;
    justify-content: flex-end;
  }

  .column1 {
    text-align: right;
    margin-right: 5px;
    flex: 40%;
  }

  .column2 {
    flex: 60%;
  }

  .input {
    width: 100%;
    box-sizing: border-box;
  }

  .image {
    margin: 5px auto 15px;
  }

</style>
